export default __webpack_public_path__ + "static/illustration-1-d5eedce6c738bf1fa6c39cab454b62af.svg";